module.exports = __webpack_public_path__ + "assets/img/envelope-success-2c307c7bc0d01664fa5343db5c4b52eb.svg";